import { generateTestId } from "@client-shared";

export const setProductsViewTestId = (identifier: string): string =>
  generateTestId("ProductsView", identifier);
